import type { Space } from '@sb/routine-runner';

import { findNonFiniteNumberPath } from './findNonFiniteNumberPath';

/**
 * Throws if `item` carries a non-finite number — typically the `NaN` an emptied
 * number field reports, which serializes to `null`, fails `Space.Item` parse on
 * read-back, and makes every reader skip the item (see
 * `convertRoutineResponse`). Writing it destroys the stored item and all of its
 * positions, so callers on the persistence boundary fail the save instead: the
 * editor surfaces a toast, reverts, and the stored item stays intact.
 */
export function assertSpaceItemPersistable(item: Space.Item): void {
  const badPath = findNonFiniteNumberPath(item);

  if (badPath) {
    throw new Error(
      `Cannot save space item "${item.name}": ${badPath} is not a valid number`,
    );
  }
}
